import { CwxBackend } from '@/types/cwxBackend';
import { RouteRecordRaw } from 'vue-router';
import { layoutAreaTypes } from '@/types/layoutTypes';

const userAreaRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/userArea/WelcomePage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/welcomepage',
    name: 'Welcome Page',
    component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/WelcomePage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/Account',
    meta: { layout: layoutAreaTypes.User },
    children: [
      {
        path: 'Details/:userId?',
        name: 'Account Profile Details',
        component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/AccountPage.vue'),
        props: { view: CwxBackend.FrontendViews.AccountDetails, forceEditMode: false },
      },
      {
        path: 'Edit/:userId?',
        name: 'Account Profile Edit',
        component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/AccountPage.vue'),
        props: { view: CwxBackend.FrontendViews.AccountDetails, forceEditMode: true },
      },
      {
        path: 'Settings/:userId?',
        name: 'Account Settings',
        component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/AccountPage.vue'),
        props: { view: CwxBackend.FrontendViews.AccountSettings },
      },
      {
        path: 'NotificationsSettings/:userId?',
        name: 'Account Notifications',
        component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/AccountPage.vue'),
        props: { view: CwxBackend.FrontendViews.AccountNotifications },
      },
      {
        path: 'ReplacementSettings',
        name: 'Account Absence',
        component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/AccountPage.vue'),
        props: { view: CwxBackend.FrontendViews.AccountAbsence },
      },
      {
        path: 'ChangePassword/:userId?',
        name: 'Account Password',
        component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/AccountPage.vue'),
        props: { view: CwxBackend.FrontendViews.AccountPassword },
      },
    ],
  },
  {
    path: '/IdeaManagement',
    meta: { layout: layoutAreaTypes.User },
    redirect: '/IdeaManagement/Index',
    children: [
      {
        path: 'List/:spaceId',
        name: 'Idea List',
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/userArea/IdeasListPage.vue'),
      },
      {
        path: 'Index',
        name: 'Global Ideas List',
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/userArea/GlobalIdeasListPage.vue'),
      },
      {
        path: 'Details/:ideaId',
        name: 'Idea Details',
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/userArea/IdeaDetailsPage.vue'),
      },
      {
        path: 'draft/:ideaId',
        name: 'Idea Draft',
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/userArea/IdeaDraftPage.vue'),
      },
      {
        path: 'edit/:ideaId',
        name: 'Idea Edit',
        component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/IdeaEditPage.vue'),
      },
      {
        path: 'myideaslist',
        name: 'My Items',
        component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/MyItemsPage.vue'),
      },
      {
        path: 'spaces/:spaceId/idea/:ideaId/submit-child',
        name: 'IdeaChildSubmit',
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/userArea/IdeaSubmitChildPage.vue'),
      },
    ],
  },
  {
    path: '/tasks/mytasks',
    name: 'My tasks',
    component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/MyTasksPage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/scorecard/create/:spaceId',
    name: 'scorecardCreateDefinition',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/userArea/ScorecardCreateDefinitionPage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/scorecard/definition/:scorecardId',
    name: 'scorecardEditDefinition',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/userArea/ScorecardEditDefinitionPage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/scorecard/evaluators/:scorecardId',
    name: 'scorecardSelectEvaluators',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/userArea/ScorecardEditEvaluatorsPage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/scorecard/selectitems/:scorecardId',
    name: 'scorecardSelectItems',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/userArea/ScorecardEditSelectItemsPage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/spaces/:spaceId/submitidea',
    name: 'Idea Submit',
    component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/IdeaSubmitPage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/ideamanagement/createbasedonanotheridea',
    name: 'Create based on another idea',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/userArea/CreateBasedOnAnotherIdeaPage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/ideamanagement/createbasedoncompetitionanswer',
    name: 'Create based on competition answer',
    component: () =>
      import(
        /* webpackChunkName: "home" */ '@/views/userArea/CreateBasedOnCompetitionAnswerPage.vue'
      ),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/space/:spaceId',
    name: 'Space Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/SpaceHomePage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/challenges',
    name: 'Challenges List',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/userArea/ChallengesListPage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/utilandrewards/myrewardslist',
    name: 'My Rewards',
    component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/MyRewardsPage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/Pages/:urlName',
    name: 'HtmlPages',
    component: () => import(/* webpackChunkName: "home" */ '@/views/userArea/HtmlPagePage.vue'),
    meta: { layout: layoutAreaTypes.User },
  },
  {
    path: '/Search',
    name: 'SearchResults',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/userArea/SearchResultsPage.vue'),
    meta: { layout: layoutAreaTypes.User },
    props: (route) => ({ searchPhrase: route.query.searchPhrase }),
  },
];

export default userAreaRoutes;
